import { z } from "zod";

export const getDriverMileageGapByCompanyPayloadSchema = z.object({
  companyUuid: z.uuid(),
  month: z.iso.datetime(),
  mileageGapPercentage: z.coerce.number(),
});

export type GetDriverMileageGapByCompanyPayload = z.infer<
  typeof getDriverMileageGapByCompanyPayloadSchema
>;
